import {Component, Input, OnChanges} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Project} from '../../model/project';

@Component({
    selector: 'project-list',
    template: `
      <div class="bg-dark border-right" id="sidebar-wrapper">
        <div class="sidebar-heading">Projects List</div>
        <div class="list-group" role="tablist">
          <div id="custom-search-input" class="input-group col-md-12">
                <input type="text" class="form-control input-lg" placeholder="{{'Spotlight'|translate}}" [(ngModel)]="search" />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" (click)="onAdvancedSearch()" title="Advanced Search"><i class="fas fa-search"></i></button>
              </div>
          </div>
          <br/>

          <div *ngFor="let project of projects | name:search:'name' " data-toggle="tooltip" data-placement="right" title="{{project.name}}" data-content="popContent">
            <div  class="folders list-group-item list-group-item-action">
                <ng-container *ngIf="!project.webProject">
              <span><i style="color: #ffe793" [ngClass]="project.isSelected ? 'fas fa-folder-open':'fas fa-folder'"></i></span>
              <a  class="folderName" [routerLink]="[project.id]">{{adaptName(project.name)}}</a>
              <span style="position: absolute; top: 5px; left: 90%; padding-top: 10px;"  triggers="mouseenter:mouseleave"
                     class="chevron hand" data-toggle="collapse" [attr.data-target]="'#' + generateLinkId(project.name)">
                                <i (click)="toggle(project)" [ngClass]="project.isSelected ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
                    </span>
                </ng-container>
                <ng-container *ngIf="project.webProject">
                    <span><img class="webFolderIcon" src="../../../assets/images/webFolder.png" alt="Terminal"></span>
                    <a  class="folderName" [routerLink]="[project.id]">{{project.name}}</a>
                    <span style="position: absolute; top: 5px; left: 90%; padding-top: 10px;"  triggers="mouseenter:mouseleave"
                          class="chevron hand" data-toggle="collapse" [attr.data-target]="'#' + generateLinkId(project.name)">
                                <i (click)="toggle(project)" [ngClass]="project.isSelected ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
                    </span>
                </ng-container>
            </div>
            <div id="{{generateLinkId(project.name)}}" class="list-group" [ngClass]="project.isSelected ? 'collapse in' : 'collapse'">
              <div id="listQuestionnaires">
                <div  *ngFor="let questionnaire of project.questionnaires" class="files list-group-item just-padding" data-toggle="tooltip" data-placement="right" title="{{questionnaire.name}}">
                  <span id="questionnaire"><i style="color:#3ab5e6" class="fas fa-file-alt"></i></span>
                  <a class="questionnaireName" (click)="onQuestionnaireClicked(adaptName(questionnaire.name))" [routerLink]="[project.id, questionnaire.id]"> {{adaptName(questionnaire.name)}} </a>
                </div>
              </div>
            </div>
            <!-- template for popover -->
            <template #popContent>
                <div> <b>Code: </b> {{project.code}}</div>
                <div> <b>Client: </b> {{project.client.name}}</div>
                <div> <b>U: </b> {{project.client.username}}</div>
                <div> <b>P: </b> {{project.client.password}}</div>
            </template>
        </div>
                <!--<template #popContent>
                    <div> <b>Code: </b> {{project.code}}</div>
                    <div> <b>Client: </b> {{project.client.name}}</div>
                    <div> <b>U: </b> {{project.client.username}}</div>
                    <div> <b>P: </b> {{project.client.password}}</div>
                </template>
            </div>

        </div>-->


    </div>
        </div>

    `,
    styles: [
        `          .files {
        border-left: 5px solid #17a2b8;
      }
        .webFolderIcon{width:25px;}
      .folders {
        border-left: 5px solid #B8744F;
          -moz-border-radius: 5px;
          -webkit-border-radius: 5px;
          -moz-box-shadow: inset 0 0 1px #fff;
          -webkit-box-shadow: inset 0 0 1px #fff;
          background: -webkit-gradient(
                  linear,
                  center top,
                  center bottom,
                  from(#327aa4),
                  color-stop(45%, #2e4b5a),
                  to(#5cb0dc)
          );
          background: -moz-linear-gradient(
                  top,
                  rgba(50, 123, 165, 0.75),
                  rgba(46, 75, 90, 0.75) 50%,
                  rgba(92, 176, 220, 0.75)
          );
          border: solid 1px #102a3e;
          box-shadow: inset 0 0 1px #fff;
          display: inline-block;
          overflow: visible;
      }

      .folders:hover {
          -moz-border-radius: 3px;
          -webkit-border-radius: 3px;
          -moz-box-shadow: inset 0 0 1px #fff;
          -webkit-box-shadow: inset 0 0 1px #fff;
          border: solid 1px #000;
          background-color: #658da0;
          background: -moz-linear-gradient(center left,
                  rgba(81, 115, 132, 0.55),
                  rgba(121, 163, 184, 0.55) 50%,
                  rgba(81, 115, 132, 0.55)
          );
          background: -webkit-gradient(
                  linear,
                  0% 100%,
                  100% 100%,
                  from(#517384),
                  color-stop(50%, #79a3b8),
                  to(#517384)
          );
          box-shadow: 0 0 1px #fff;
      }

      .files {
        background-color: #000000;
          margin-left:3%;
          margin-right:3%;
          margin-top:3%;
          margin-bottom:3%;
      }
      .files:hover {
          -moz-border-radius: 3px;
          -webkit-border-radius: 3px;
          -moz-box-shadow: inset 0 0 1px #fff;
          -webkit-box-shadow: inset 0 0 1px #fff;
          border: solid 1px #000;
          background-color: #658da0;
          background: -moz-linear-gradient(
                  center left,
                  rgba(81, 115, 132, 0.55),
                  rgba(121, 163, 184, 0.55) 50%,
                  rgba(81, 115, 132, 0.55)
          );
          background: -webkit-gradient(
                  linear,
                  0% 100%,
                  100% 100%,
                  from(#517384),
                  color-stop(50%, #79a3b8),
                  to(#517384)
          );
          box-shadow: 0 0 1px #fff;
      }

      .folderName {
        color: white;
      }

      .list-group .list-group-item:first-child {
        border-radius: 0;
      }

      .questionnaireName{color:white;}

      #custom-search-input {
        padding: 0;
        border: solid 1px #E4E4E4;
        border-radius:0;
        background-color: #f5f5f5;
      }

      #custom-search-input input {
        border: 0;
        box-shadow: none;
        font-size: 14px;
        background-color: #f5f5f5;
      }

      #custom-search-input button {
        margin: 2px 0 0 0;
        background: none;
        box-shadow: none;
        border: 0;
        color: #666666;
        padding: 0 8px 0 10px;
        border-left: solid 1px #ccc;
      }

      #custom-search-input button:hover {
        border: 0;
        box-shadow: none;
        border-left: solid 1px #ccc;
      }

      #custom-search-input .glyphicon-search {
        font-size: 14px;
      }

      #listQuestionnaires {
          background-color: black;
      }
      #questionnaire{ padding-left: 10px;}

      a {
        margin-left: 10px;
      }

      .chevron {
          color: white;
        position: absolute;
        top: 5px;
        left: 70%;
        padding-top: 10px;
      }`
    ]
})
export class ProjectListComponent implements OnChanges {

    /*private _showAddProjectDialog: boolean = false;
    private _showCreateQuestionnaireDialog: boolean = false;
    public CHOICE_CLAZZS;
    public QUESTION_CLAZZS;
    public QUESTION_TYPES;
    public POST_SYNCHRO_ACTION;
    public isCustomConfig = false;
    private hasSubChoice = false;
    private isSelectedLanguage = false;
    listClients: Client[];
    error = '';


    options = ['Fr', 'En'];
    optionsMap = [{
        Fr: false,
        En: false
    }];
    optionsChecked = [];*/



    constructor(private _router: Router, private  _activatedRouter:ActivatedRoute) {
        /*this.CHOICE_CLAZZS = constants.CHOICE_CLAZZS;
        this.QUESTION_CLAZZS = constants.QUESTION_CLAZZS;
        this.QUESTION_TYPES = constants.QUESTION_TYPES;
        this.POST_SYNCHRO_ACTION = constants.POST_SYNCHRO_ACTION;*/
    }
    @Input('projects') projects: Project[];


    /*createObjectDialog() {
        console.log(this._project);
        this._project.projectDescriptor.code = this._project.code;
        this._project.projectDescriptor.name = this._project.name;
        for (var i = 0; i < this._project.projectDescriptor.questionnairesDescriptor.length; i++) {

            var questionnaireTemp = this._project.questionnaires[i];
            //inferer title, email,   SMS
            questionnaireTemp.title = this._project.projectDescriptor.questionnairesDescriptor[i].questionnaireTitle;
            questionnaireTemp.email = this._project.projectDescriptor.questionnairesDescriptor[i].email;
            questionnaireTemp.sms = this._project.projectDescriptor.questionnairesDescriptor[i].sms;
            this._project.projectDescriptor.questionnairesDescriptor[i].questionnaireSrc = "questionnaire" + (i + 1) + ".json";
            questionnaireTemp.uiFile.fileName = "questionnaire" + (i + 1) + ".xml";
            var file = new FileToDownload("questionnaire" + (i + 1) + ".xml", "questionnaire", "desktop");
            this._project.projectDescriptor.questionnairesDescriptor[i].filesToDownload.push(file);
            //inferer userclient type
            this._project.projectDescriptor.questionnairesDescriptor[i].userClient.type = questionnaireTemp.uiFile.deviceName

            // set no of questions
            if (questionnaireTemp.questions != null) {
                for (var j = 0; j < questionnaireTemp.questions.length; j++) {
                    var questionTemp = questionnaireTemp.questions[j];
                    questionTemp.no = j + 1;
                     // set no of choices
                    if (questionTemp.choices != null) {
                        for (var k = 0; k < questionTemp.choices.length; k++) {
                            var choiceTemp = questionTemp.choices[k];
                            choiceTemp.no = k + 1;
                             // set no of subchoices
                            if (choiceTemp.subChoices != null) {
                                for (var l = 0; l < choiceTemp.subChoices.length; l++) {
                                    choiceTemp.subChoices[l].no = l + 1;
                                }
                            }
                        }
                    }
                }
            }



        }

        this._showAddProjectDialog = false;

        this._projectService.createObjectDialog(this._project)
            .subscribe(data => {
                console.log(data);
            },
            error => console.log("Error downloading the file."));
    }*/

    private string;
  search: any;
    /*initOptionsMap() {
        for (var x = 0; x < this.options.length; x++) {
            this.optionsMap[this.options[x]] = false;
        }
    }*/

    ngOnChanges() {


      console.log('project list ngOnChanges');
      if (this.projects != null && this.projects.length > 0) {
        const projectId = localStorage.getItem('project_id');
        let link;
        let project: Project = null;

        if (projectId != null) {
          project = this.getProject(projectId);
        }

        if (project != null) {
          if (project.questionnaires != null && project.questionnaires.length > 0) {
            link = ['project', project.id, project.questionnaires[0].id];
          } else {
            link = ['project', project.id];
          }
        } else {
          if (this.projects[0].questionnaires != null && this.projects[0].questionnaires.length > 0) {
            link = ['project', this.projects[0].id, this.projects[0].questionnaires[0].id];
          }  else {
            link = ['project', this.projects[0].id];
          }

        }
        console.log(link);
        this._router.navigate(link);
      }
    }



    /*updateCheckedOptions(option, event, indexQuestioquestionnaire-project     this.optionsMap[indexQuestionnaire][option] = event.target.cquestionnaire-project   this._project.questiquestionnaire-projectxQuestionnaire].languages.length = 0;

        if (this._project.questionnaires != null && this._project.questionnaires.length > 0) {
            if (this.optionsMap[indexQuestionnaire].Fr != null && this.optionsMap[indexQuestionnaire].Fr == true && this.optionsMap[indexQuestionnaire].En != null && this.optionsMap[indexQuestionnaire].En == true) {
                this.isSelectedLanguage = true;
                this._project.questionnaires[indexQuestionnaire].languages.push("En");
                this._project.questionnaires[indexQuestionnaire].languages.push("Fr");


            } else if (this.optionsMap[indexQuestionnaire].Fr != null && this.optionsMap[indexQuestionnaire].Fr == true) {

                this._project.questionnaires[indexQuestionnaire].languages.push("Fr")
                this.isSelectedLanguage = true;
            }
            else if (this.optionsMap[indexQuestionnaire].En != null && this.optionsMap[indexQuestionnaire].En == true) {
                this.isSelectedLanguage = true;
                this._project.questionnaires[indexQuestionnaire].languages.push("En")
            } else {
                this.isSelectedLanguage = false;
            }
        }
        console.log(this._project.questionnaires[indexQuestionnaire].languages);
    }


    checkComboSelected(indexQuestionnaire, indexQuestion, event) {
        if (event == "combo") {
            console.log(this._project.questionnaires[indexQuestionnaire].questions[indexQuestion].choices)
            if (this._project.questionnaires[indexQuestionnaire].questions[indexQuestion].choices == null || this._project.questionnaires[indexQuestionnaire].questions[indexQuestion].choices.length == 0) {
                this.addChoice(indexQuestionnaire, indexQuestion);
            }
        }
    }

    onSelectPostSynchro(indexQuestionnaire, indexPostSynchro, postSynchro) {
        console.log(postSynchro);

        if (postSynchro.value == (this.POST_SYNCHRO_ACTION.length - 1)) {
            this.isCustomConfig = true;
        } else {
            this._project.projectDescriptor.questionnairesDescriptor[indexQuestionnaire].postSyncActions[indexPostSynchro].clazz = this.POST_SYNCHRO_ACTION[postSynchro].clazz
            this._project.projectDescriptor.questionnairesDescriptor[indexQuestionnaire].postSyncActions[indexPostSynchro].config = this.POST_SYNCHRO_ACTION[postSynchro].config;
            this.isCustomConfig = false;
        }
    }

    updateOptions() {
        for (var x in this.optionsMap) {
            if (this.optionsMap[x]) {
                this.optionsChecked.push(x);
            }
        }
    }

    addQuestionnaire() {
        this._project.addEmptyQuestionnaireDescriptor();
        this.optionsMap.push({
            Fr: false,
            En: false
        });
    }

    removeQuestionnaire(index) {
        this._project.projectDescriptor.questionnairesDescriptor.splice(index, 1);
        this._project.questionnaires.splice(index, 1);
        this.optionsMap.splice(index, 1);
    }

    removeQuestion(indexQuestionnaire, indexQuestion) {
        console.log("indexQuestion : " + indexQuestion + "; indexQuestionnaire: " + indexQuestionnaire);
        this._project.questionnaires[indexQuestionnaire].questions.splice(indexQuestion, 1);
    }

    removeFile(indexQuestionnaire, indexFile) {
        this._project.projectDescriptor.questionnairesDescriptor[indexQuestionnaire].filesToDownload.splice(indexFile, 1);
    }

    removeSynchro(indexQuestionnaire, indexSynchro) {
        this._project.projectDescriptor.questionnairesDescriptor[indexQuestionnaire].postSyncActions.splice(indexSynchro, 1);
    }

    removeSubChoice(indexQuestionnaire, indexQuestion, indexSubChoice) {
        this._project.questionnaires[indexQuestionnaire].questions[indexQuestion].choices[0].subChoices.splice(indexSubChoice, 1);
    }
    removeChoice(indexQuestionnaire, indexQuestion, indexChoice) {
        this._project.questionnaires[indexQuestionnaire].questions[indexQuestion].choices.splice(indexChoice, 1);
    }


    addSynchro(indexQuestionnaire) {
        this._project.projectDescriptor.questionnairesDescriptor[indexQuestionnaire].addEmptypostSyncAction();
    }

    addFile(indexQuestionnaire) {
        this._project.projectDescriptor.questionnairesDescriptor[indexQuestionnaire].addEmptyFileToDownload();
    }

    addQuestion(indexQuestionnaire) {
        this._project.questionnaires[indexQuestionnaire].addEmptyQuestion();
    }

    addChoice(indexQuestionnaire, indexQuestion) {
        this._project.questionnaires[indexQuestionnaire].questions[indexQuestion].addEmptyChoice();
    }

    addSubChoice(indexQuestionnaire, indexQuestion) {
        this._project.questionnaires[indexQuestionnaire].questions[indexQuestion].choices[0].addEmptySubChoice();
    }


    onNavbarClick() {
        this._showAddProjectDialog = !this._showAddProjectDialog;
    }

    showCreateQuestionnaire() {
        this._showCreateQuestionnaireDialog = !this._showCreateQuestionnaireDialog;
    }
    hideDialog() {
        this._showAddProjectDialog = false;
    }*/

    toggle(project:Project) {
        project.isSelected = !project.isSelected;
    }

   /* addProject() {
        this.projects.push(this._project);
        this._showAddProjectDialog = false;
        console.log(this.projects);
    }*/




    /*loadAllClients() {
        this._projectService.getClients()
            .then(
            clients => {
                this.listClients = clients;
            },
            error => this.errorMessage = <any>error);
    }*/



    private adaptName(name:string):string {
        if(name.length>18) {
            return name.substr(0,14)+'...';
        }
        return name;
    }


    getProject(projectId): Project {
        let project: Project = null;
        for (const p of this.projects) {
            if (p.id === projectId) {
                project = p;
                break;
            }
        }
        return project;
    }
    private generateLinkId(name:string) {
        return name.replace(/(\s+)/g,'');
    }

  onAdvancedSearch() {
    console.log(this._activatedRouter.parent);
    this._router.navigate(['search'],{relativeTo:this._activatedRouter});
  }

   private onQuestionnaireClicked(s: string) {
       localStorage.setItem('selectedQuestionnaire',s);
    }
}
